import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DocumentForm from '../../components/Documents/DocumentForm';
import Toast from '../../components/Common/Toast';

const CreateDocument = () => {
  const navigate = useNavigate();
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  const handleSuccess = () => {
    setToast({
      isOpen: true,
      message: 'Documento creado exitosamente',
      type: 'success'
    });
    setTimeout(() => {
      navigate('/documents');
    }, 1500);
  };

  const handleCancel = () => {
    navigate('/documents');
  };

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nuevo Documento</h1>
          <p className="text-gray-600 mt-1">Complete el formulario para crear un nuevo documento</p>
        </div>

        {/* Formulario */}
        <DocumentForm
          isOpen={true}
          onClose={handleCancel}
          document={null}
          onSuccess={handleSuccess}
          isPageMode={true}
        />

        {/* Toast de notificaciones */}
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default CreateDocument;


